import React, { createRef, useEffect, useRef, useState } from "react"
import MyMovementsContent from "../components/organisms/my-movements-content/my-movements-content"
import Layout from "../shared/components/organisms/layout/layout"
import SEO from "../shared/seo"
import "../shared/styles/index.scss"
import ModalFidelization from "../components/molecules/modal-fidelization/modal-fidelization"

import { siteUrl } from "../shared/utils/siteUrl"
import ModalExpiredPoints from "../components/molecules/modal-expired-points/modal-expired-points"
import { requestExpiredPoints } from "../utils/requestExpiredPoints"
import { LOCALE } from "../constants/country.constants"

const MyMovements = () => {
  const [modalActive, setModalActive] = useState()
  // var news_info=props.dataProp
  const [isMobile, setMobileBool] = useState(false)
  // send active modal to layout
  const updateDimensions = () => {
    setMobileBool(window.innerWidth < 1024 ? true : false)
  }
  const getUserData = () => {
    if (!localStorage.hasOwnProperty("USER_INFO")) {
      return null
    }
    try {
      return JSON.parse(localStorage.getItem("USER_INFO"))
    } catch (e) {
      return null
    }
  }
  const validateToCallExpiredModal = () => {
    if (["es-BO", "es-UY"].includes(LOCALE)) {
      return
    }
    let userData = getUserData()
    if (!userData) {
      return
    }
    requestExpiredPoints().then(points => {
      if (points < 1) {
        return
      }
      setModalActive(
        <ModalExpiredPoints
          points={points}
          user={userData}
          onClose={() => {
            setModalActive(null)
          }}
        />
      )
    })
  }
  useEffect(() => {
    if (!localStorage.getItem("TOKEN_INFO")) {
      sessionStorage.setItem("NEXT_PAGE", window.location.pathname)
      window.location.replace(siteUrl + "/login")
    }

    updateDimensions()
    validateToCallExpiredModal()
    window.addEventListener("resize", updateDimensions)
    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [])

  return (
    <Layout
      mobile={isMobile}
      modalActive={modalActive}
      title="Mis Puntos - ¿Qué puedo ganar?"
    >
      <SEO
        title="Mis Puntos - ¿Qué puedo ganar?"
        url={"/mis-puntos/mis-movimientos/"}
      />

      <ModalFidelization />

      <MyMovementsContent mobile={isMobile} />
    </Layout>
  )
}
export default MyMovements
